<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />
  <!-- FILTROS -->
  <div class="card">
    <div class="card-header">
      <h5 class="card-title">Filtrar auditório</h5>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-sm-3">
          <div class="form-group">
            <label for="nome">Id leilão</label>
            <input class="form-control" id="id" v-model="leilao_id" />
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <label for="endereco_estado">Exibir</label>

            <select class="custom-select rounded-0" id="endereco_estado" v-model="filtro_leiloes">
              <option value="abertos">Somente abertos</option>
              <option value="todos">Todos os leilões</option>
            </select>
          </div>
        </div>

        <div class="col-sm-12">
          <div class="form-group">
            <button type="button" class="btn btn-primary" @click="buscarLeiloes()">Buscar</button>

            <button type="button" class="btn btn-default" @click="limparFiltros" style="margin-left: 15px">Limpar filtros</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div style="padding: 0px 0px 10px 0px; color: red" v-if="searchBuscado">Exibindo resultados para "{{ filtro }}"</div>

  <div class="row" style="width: 100%" id="leiloes">
    <div class="col-6 col-sm-12 col-md-4 md-div" v-for="leilao in leiloes" :key="leilao" :value="leilao" v-if="leiloes">
      <div class="card" v-if="leilao">
        <div
          class="card-body"
          style="
            padding: 0px 0px 0px 0px;
            text-align: left;
            font-family: 'Montserrat', sans-serif;
            text-transform: uppercase;
            margin: 0px 0px 0px 0px;
          "
        >
          <div style="border-bottom: 2px solid gray; text-align: left; line-height: 17px" class="p-2">
            <img width="75px" height="45px" :src="getLeilaoPath(leilao)" style="top: 5px; left: 5px; position: absolute" />
            <div style="margin-top: 7px; margin-left: 80px; position: relative">
              <span style="font-size: 14px; font-weight: bold; word-wrap: break-">#{{ leilao.id }} - {{ leilao.cidade }} - {{ leilao.estado }}</span>
              <br />
              <span style="font-size: 14px; font-weight: bold; word-wrap: break-word">{{ getFormatedTitle(leilao.leilao_titulo) }}</span>
              <br />
              <span style="font-size: 14px; font-weight: bold; word-wrap: break-word">Leilão ID {{ leilao.id }}</span>
              <br />

              <!-- DATAS E VALORES DOS LEILÕES -->
              <div
                v-if="leilao.leilao_num_pracas > 1 && leilao.leilao_1_modalidade != 'venda'"
                style="border-bottom: none; text-align: left; line-height: 20px"
              >
                <div style="font-size: 14px">
                  <b :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''">1º Leilão:&nbsp;</b>
                  <span :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''">
                    {{ formatDate(leilao.leilao_1_data) + "h" }}
                  </span>
                </div>

                <!-- DATA 2 -->
                <div style="font-size: 14px" v-if="leilao.leilao_num_pracas >= 2">
                  <b :class="leilao.leilao_2_realizado === 1 ? 'realizado' : ''">2º Leilão:&nbsp;</b>
                  <span :class="leilao.leilao_2_realizado === 1 ? 'realizado' : ''">
                    {{ formatDate(leilao.leilao_2_data) + "h" }}
                  </span>
                </div>

                <!-- DATA 3 -->
                <div style="font-size: 14px" v-if="leilao.leilao_num_pracas >= 3">
                  <b :class="leilao.leilao_3_realizado === 1 ? 'realizado' : ''">3º Leilão:&nbsp;</b>
                  <span :class="leilao.leilao_3_realizado === 1 ? 'realizado' : ''">
                    {{ formatDate(leilao.leilao_3_data) + "h" }}
                  </span>
                </div>

                <!-- DATA 4 -->
                <div style="font-size: 14px" v-if="leilao.leilao_num_pracas >= 4">
                  <b :class="leilao.leilao_4_realizado === 1 ? 'realizado' : ''">4º Leilão:&nbsp;</b>
                  <span :class="leilao.leilao_4_realizado === 1 ? 'realizado' : ''">
                    {{ formatDate(leilao.leilao_4_data) + "h" }}
                  </span>
                </div>
              </div>

              <!-- ÚNICO LEILÃO-->
              <div
                v-else-if="leilao.leilao_num_pracas == 1 && leilao.leilao_1_modalidade != 'venda'"
                style="border-bottom: none; text-align: left; line-height: 20px"
              >
                <div style="font-size: 14px; margin-bottom: 3px" :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''">
                  <b>Único leilão:</b>
                  {{ formatDate(leilao.leilao_1_data) + "h" }}
                </div>
              </div>

              <!-- VENDA DIRETA -->
              <div v-else-if="leilao.leilao_1_modalidade == 'venda'" style="border-bottom: none; text-align: left; line-height: 20px">
                <br />
                <div style="font-size: 14px; margin-bottom: 3px" :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''">
                  <b>Disponível até:</b>
                  {{ formatDate(leilao.leilao_1_data) + "h" }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer clearfix" style="padding: 5px 5px 5px 5px">
          <button
            data-toggle="modal"
            data-target="#visualizar-usuarios-online"
            @click="leilao_selecionado = leilao"
            style="font-size: 12px; border-radius: 2px"
            type="submit"
            class="btn btn-default"
            title="Usuários online"
            alt="Usuários online"
          >
            <div v-if="leilao.usuarios_online">
              <i class="fa-solid fa-user"></i>
              {{ leilao.usuarios_online.length }}
            </div>
            <div v-else>
              <i class="fa-solid fa-user"></i>
              0
            </div>
          </button>
          <button
            style="font-size: 12px; border-radius: 2px; margin-left: 5px"
            type="submit"
            class="btn btn-default"
            data-toggle="modal"
            data-target="#visualizar-habilitacoes"
            @click="leilao_selecionado = leilao"
            title="Habilitações"
            alt="Habilitações"
          >
            <div v-if="leilao.habilitacoes">
              <i class="fa-solid fa-laptop"></i>
              {{ leilao.habilitacoes.length }}
            </div>
            <div v-else>
              <i class="fa-solid fa-laptop"></i>
              0
            </div>
          </button>
          <button
            style="font-size: 12px; border-radius: 2px; margin-left: 5px"
            type="submit"
            class="btn btn-default"
            data-toggle="modal"
            data-target="#visualizar-lances"
            title="Lances"
            alt="Lances"
            @click="(lotes = leilao.lotes_ordenados), (leilao_selecionado = leilao), (lances = leilao.lances), (lote_selecionado = '')"
          >
            <div v-if="leilao.lances">
              <i class="fa-solid fa-gavel"></i>
              {{ leilao.lances.length }}
            </div>
            <div v-else>
              <i class="fa-solid fa-gavel"></i>
              0
            </div>
          </button>
          <button
            style="font-size: 12px; border-radius: 2px; margin-left: 5px"
            type="submit"
            class="btn btn-default"
            data-toggle="modal"
            data-target="#visualizar-regressiva"
            title="Regressiva"
            alt="Regressiva"
            @click="(lotes = leilao.lotes_ordenados), (leilao_selecionado = leilao)"
          >
            <i class="fa-regular fa-clock"></i>
          </button>
          <button
            style="font-size: 12px; border-radius: 2px; margin-left: 5px"
            type="submit"
            class="btn btn-default"
            title="Propostas"
            alt="Propostas"
            @click="exibirPropostas(leilao), (exibir_propostas = true)"
          >
            <div v-if="leilao.propostas">
              <i class="fa-solid fa-comment-dollar"></i>
              {{ leilao.propostas }}
            </div>
            <div v-else>
              <i class="fa-solid fa-comment-dollar"></i>
              0
            </div>
          </button>
          <button style="font-size: 12px; border-radius: 2px; margin-left: 5px" type="submit" class="btn btn-default" title="Lotes" alt="Lotes">
            <div v-if="leilao.lotes">
              <i class="fa-solid fa-layer-group"></i>
              {{ leilao.lotes.length }}
            </div>
            <div v-else>
              <i class="fa-solid fa-layer-group"></i>
              0
            </div>
          </button>
          <a
            :href="'/admin/auditorio_user/' + leilao.id"
            target="_blank"
            style="font-size: 12px; border-radius: 2px; margin-left: 5px"
            type="submit"
            class="btn btn-default"
            title="Auditório usuário"
            alt="Auditório usuário"
          >
            <i class="fa-solid fa-right-to-bracket"></i>
            Auditório usuário
          </a>
        </div>
      </div>
    </div>

    <div class="col-sm-12" v-if="leiloes">
      <div class="card-footer clearfix">
        <!-- TOTAIS  -->
        <div style="font-size: 13px" class="float-left" aria-live="polite">
          Exibindo do {{ inicio + 1 }} ao {{ inicio + leiloes.length }}
          <p>Total {{ total }}</p>
        </div>

        <div class="card-tools">
          <div class="input-group input-group-sm" style="width: 150px">
            <!--
            <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

            <select @change="alterarQtdPagina()" class="card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
              <option :value="3">3</option>
              <option :value="12">12</option>
              <option :value="24">24</option>
              <option :value="48">48</option>
              <option :value="96">96</option>
            </select>[-->
          </div>
        </div>

        <!-- PAGINAÇÃO  -->
        <ul class="pagination pagination-sm m-0 float-right">
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

          <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
            <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
              {{ pagina }}
            </a>
          </li>

          <li class="page-item">
            <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
          </li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
        </ul>
      </div>
    </div>
  </div>

  <admin-auditorio-propostas v-if="exibir_propostas" :leilao="leilao_selecionado" :setListarProposta="setListarProposta" />

  <!-- MODAL HABILITADOS -->
  <div
    class="modal fade"
    id="visualizar-habilitacoes"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="margin-top: 30px"
    v-if="leilao_selecionado && leilao_selecionado.habilitacoes && leilao_selecionado.habilitacoes.length"
  >
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4>Visualizar habilitações</h4>
            <br />
            <div class="card card-primary">
              <div class="card-body">
                <table class="table table-hover text-nowrap">
                  <thead>
                    <tr>
                      <th>Seq</th>
                      <th>Apelido</th>
                      <th>Nome</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(habilitacao, index) in leilao_selecionado.habilitacoes" :key="habilitacao">
                      <td>{{ index + 1 }}</td>
                      <td>
                        <a :href="'/admin/cadastros/detalhes/' + habilitacao.user_id">{{ habilitacao.apelido }}</a>
                      </td>
                      <td>
                        <a :href="'/admin/cadastros/detalhes/' + habilitacao.user_id">{{ habilitacao.nome_completo }}</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="card-footer">
                <button data-dismiss="modal" aria-hidden="true" class="btn btn-danger">Fechar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- MODAL USUÁRIOS ONLINE -->
  <div
    class="modal fade"
    id="visualizar-usuarios-online"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="margin-top: 30px"
    v-if="leilao_selecionado && leilao_selecionado.usuarios_online && leilao_selecionado.usuarios_online.length"
  >
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4>Usuários online</h4>
            <br />
            <div class="card card-primary">
              <div class="card-body">
                <table class="table table-hover text-nowrap">
                  <thead>
                    <tr>
                      <th>Seq</th>
                      <th>Apelido</th>
                      <th>Nome</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(usuario_online, index) in leilao_selecionado.usuarios_online" :key="usuario_online">
                      <td>{{ index + 1 }}</td>
                      <td>
                        <a :href="'/admin/cadastros/detalhes/' + usuario_online.id">{{ usuario_online.apelido }}</a>
                      </td>

                      <td>
                        <a :href="'/admin/cadastros/detalhes/' + usuario_online.id">{{ usuario_online.nome_completo }}</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="card-footer">
                <button data-dismiss="modal" aria-hidden="true" class="btn btn-danger">Fechar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- MODAL LANCES -->
  <div
    class="modal fade"
    id="visualizar-lances"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="margin-top: 30px"
    v-if="leilao_selecionado && leilao_selecionado.lances && leilao_selecionado.lances.length"
  >
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body" style="font-size: 12px">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4>Visualizar lances</h4>
            <br />

            <div class="col-sm-12">
              <div class="form-group">
                <label for="nome">Lote</label>
                <select
                  class="custom-select rounded-0"
                  id="leilao_tipo"
                  @change="filtrarLances"
                  v-model="lote_selecionado"
                  style="text-transform: uppercase"
                >
                  <option value=""></option>
                  <option v-for="lote in lotes" :key="lote" :value="lote">{{ lote.lote_numero }} - {{ getFormatedTitle(lote.lote_titulo) }}</option>
                </select>
              </div>
            </div>
            <button class="btn btn-success" @click="ExportExcel('xlsx')">Download Excel xlsx</button>
            <div class="card card-primary">
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>Seq</th>
                      <th>Lote</th>
                      <th>Data/hora</th>
                      <th>Praça</th>
                      <th>Valor</th>
                      <th>Parcelado</th>
                      <th>Apelido</th>
                      <th>Nome</th>
                      <th>Preferencial</th>
                      <th>Nível</th>
                      <th>IP</th>
                      <th>Cancelado</th>
                      <th>Motivo cancelamento</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(lance, index) in lances" :key="lance">
                      <td>{{ index + 1 }}</td>
                      <td>
                        <a :href="'/admin/leilao/' + lance.leilao_id + '/lotes/editar/' + lance.lote_id">
                          {{ lance.lote_numero }} - {{ getFormatedTitle(lance.lote_titulo) }}
                        </a>
                      </td>
                      <td>{{ formatDate(lance.created_at) }}</td>
                      <td>{{ lance.praca }}</td>
                      <td>{{ getValorLance(lance) }}</td>
                      <td>
                        <p v-if="lance.parcelado && lance.parcelado == 1">Sim</p>
                        <p v-else>Não</p>
                      </td>
                      <td>
                        <a :href="'/admin/cadastros/detalhes/' + lance.lote_lance_user_id">{{ lance.apelido }}</a>
                      </td>
                      <td>
                        <a :href="'/admin/cadastros/detalhes/' + lance.lote_lance_user_id">{{ lance.nome_completo }}</a>
                      </td>

                      <td>
                        <p v-if="lance.igualar_lance && lance.igualar_lance == 1">Sim</p>
                        <p v-else>Não</p>
                      </td>
                      <td>
                        <p v-if="lance.nivel_preferencia">{{ lance.nivel_preferencia }}</p>
                        <p v-else>0</p>
                      </td>
                      <td>{{ lance.ip }}</td>
                      <td>
                        <p v-if="lance.cancelado && lance.cancelado == 1">Sim</p>
                        <p v-else>Não</p>
                      </td>
                      <td>{{ lance.motivo_cancelamento }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="card-footer">
                <button data-dismiss="modal" aria-hidden="true" class="btn btn-danger">Fechar</button>
              </div>
            </div>

            <table class="table table-hover" v-show="false" ref="exportable_table">
              <thead>
                <tr>
                  <th>Seq</th>
                  <th>Lote</th>
                  <th>Data/hora</th>
                  <th>Praça</th>
                  <th>Valor</th>
                  <th>Parcelado</th>
                  <th>Apelido</th>
                  <th>Nome</th>
                  <th>Preferencial</th>
                  <th>Nível</th>
                  <th>IP</th>
                  <th>Cancelado</th>
                  <th>Motivo cancelamento</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(lance, index) in lances" :key="lance">
                  <td>{{ index + 1 }}</td>
                  <td>
                    <a :href="'/admin/leilao/' + lance.leilao_id + '/lotes/editar/' + lance.lote_id">
                      {{ lance.lote_numero }} - {{ getFormatedTitle(lance.lote_titulo) }}
                    </a>
                  </td>
                  <td>{{ formatDate(lance.created_at) }}</td>
                  <td>{{ lance.praca }}</td>
                  <td>{{ getValorLanceSemConversao(lance) }}</td>
                  <td>
                    <p v-if="lance.parcelado && lance.parcelado == 1">Sim</p>
                    <p v-else>Não</p>
                  </td>
                  <td>
                    <a :href="'/admin/cadastros/detalhes/' + lance.lote_lance_user_id">{{ lance.apelido }}</a>
                  </td>
                  <td>
                    <a :href="'/admin/cadastros/detalhes/' + lance.lote_lance_user_id">{{ lance.nome_completo }}</a>
                  </td>

                  <td>
                    <p v-if="lance.igualar_lance && lance.igualar_lance == 1">Sim</p>
                    <p v-else>Não</p>
                  </td>
                  <td>
                    <p v-if="lance.nivel_preferencia">{{ lance.nivel_preferencia }}</p>
                    <p v-else>0</p>
                  </td>
                  <td>{{ lance.ip }}</td>
                  <td>
                    <p v-if="lance.cancelado && lance.cancelado == 1">Sim</p>
                    <p v-else>Não</p>
                  </td>
                  <td>{{ lance.motivo_cancelamento }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- MODAL REGRESSIVA -->
  <div
    class="modal fade"
    id="visualizar-regressiva"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="margin-top: 30px"
    v-if="leilao_selecionado && lotes"
  >
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4>Visualizar regressiva</h4>
            <br />
            <div class="card card-primary">
              <div class="card-body">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="nome">Lote</label>
                    <select
                      class="custom-select rounded-0"
                      id="leilao_tipo"
                      @change="check"
                      v-model="lote_selecionado"
                      style="text-transform: uppercase"
                    >
                      <option v-for="lote in lotes" :key="lote" :value="lote">
                        {{ lote.lote_numero }} - {{ getFormatedTitle(lote.lote_titulo) }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="nome">Incremento já concedido (segundos)</label>
                    <input disabled class="form-control" id="id" v-model="lote_selecionado.lote_incremento_tempo" />
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="nome">Incremento (segundos)</label>
                    <input class="form-control" id="id" v-model="incremento" />
                  </div>
                </div>
              </div>

              <div class="card-footer">
                <button @click="addIncrementoTempo" class="btn btn-success">Salvar</button>
                <button style="margin-left: 5px" data-dismiss="modal" aria-hidden="true" class="btn btn-danger">Fechar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import wppController from "../../controller/wppController";
import sweetAlert from "../../controller/sweetAlert";
import currencyController from "../../controller/currencyController";
import Swal from "sweetalert2/dist/sweetalert2.js";
import InputMask from "primevue/inputmask";
import moment from "moment";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  mixins: [wppController, sweetAlert, Swal, currencyController],

  props: [],

  components: { Loading, InputMask },

  data() {
    return {
      container: {},
      nome: "",
      email: "",
      senha: "",
      tipo_usuario: "",
      isLoading: false,
      leiloes: "",
      paginas: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 15,
      filtro: "",
      pagina_atual: 1,
      searchBuscado: false,
      dataInicial: "",
      dataFinal: "",
      leilao_selecionado: "",
      incremento: 0,
      lote_selecionado: 0,
      propostas: [],
      exibir_propostas: false,
      lances: [],
      lotes: [],
      leilao_id: "",
      filtro_leiloes: "abertos",
    };
  },

  mounted() {
    console.log("Todos os leilões");
    this.buscarLeiloes();
    console.log(this.leiloes);
  },

  methods: {
    limparFiltros() {
      this.leilao_id = "";
      this.buscarLeiloes();
    },

    alert(text) {
      console.log(text);
    },

    getValorLance(lance) {
      return "R$" + this.toCurrency(lance.valor);
    },

    getValorLanceSemConversao(lance) {
      //return "R$" + this.toCurrency(lance.valor);
      return lance.valor;
    },

    ExportExcel(type, fn, dl) {
      let nome_arquivo = "Lances leilao " + this.leilao_selecionado.id;

      if (this.lote_selecionado) {
        nome_arquivo = nome_arquivo + " - lote " + this.lote_selecionado.lote_numero;
      }

      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, { sheet: "Sheet JS" });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(wb, fn || (nome_arquivo + "." || "SheetJSTableExport.") + (type || "xlsx"));
    },

    filtrarLances() {
      if (!this.lote_selecionado) {
        this.lances = this.leilao_selecionado.lances;
      } else {
        let lances_filtrados = [];

        for (let i = 0; i < this.leilao_selecionado.lances.length; i++) {
          if (this.leilao_selecionado.lances[i].lote_id == this.lote_selecionado.id) {
            lances_filtrados.push(this.leilao_selecionado.lances[i]);
          }
        }

        this.lances = lances_filtrados;
      }
    },

    refresh() {
      window.location.reload();
    },

    exibirPropostas(leilao) {
      this.leilao_selecionado = leilao;

      /*
      this.$nextTick(function () {
        document.getElementById("abrir_modal_propostas").click();
      });
      */
    },

    setListarProposta() {
      this.exibir_propostas = false;
    },

    selecionarLeilao(leilao) {
      this.inicio_proposta = 0;
      this.pagina_atual_proposta = 1;
      this.tamanho_proposta = this.qtd_por_pagina;

      this.leilao_selecionado = leilao;
    },

    alterarQtdPaginaProposta() {
      this.pagina_atual_proposta = 1;
      this.inicio_proposta = 0;

      this.buscarPropostas();
    },

    buscarPropostas() {
      this.isLoading = true;

      let data = {
        inicio: this.inicio_proposta,
        tamanho: this.qtd_por_pagina_proposta,
        desc: true,
        somente_pendentes: false,
        apelido: null,
        leilao_id: this.leilao_selecionado.id,
        filtro_proposta_status: "todas",
      };

      console.log("Buscando propostas");
      console.log(data);

      axios
        .post(`/admin/propostas/search`, data)
        .then((response) => {
          this.propostas = response.data.propostas;
          this.total = response.data.total;

          console.log("Leilões");
          console.log(this.propostas);

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    deletarProposta(proposta) {
      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Esta ação é irreversível, deseja continuar?</h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: proposta.id,
            };

            axios
              .post(`/admin/proposta/delete`, data)
              .then((response) => {
                console.log("Resposta delete");
                console.log(response.data);

                this.isLoading = false;
                this.showSuccessMessage("Proposta deletada!");
                this.buscarPropostas();
              })
              .catch((error) => {
                this.isLoading = false;
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    convertTiny(value) {
      if (value == 0) {
        return "Não";
      } else {
        return "Sim";
      }
    },

    addIncrementoTempo() {
      this.isLoading = true;

      let data = {
        leilao_id: this.leilao_selecionado.id,
        lote_id: this.lote_selecionado.id,
        tempo_adicional: this.incremento,
      };

      console.log("Incremento");
      console.log(data);

      axios
        .post(process.env.MIX_VUE_APP_AUDITORIO + `/validate_time`, data)
        .then((response) => {
          console.log("Resposta tempo validado");
          console.log(response.data);

           this.isLoading = false;

          if (response.data.time > 0) {
            let data = {
              lote_id: this.lote_selecionado.id,
              incremento: this.incremento,
            };

            console.log("Incremento");
            console.log(data);

            axios
              .post(`/admin/auditorio/add_incremento_tempo`, data)
              .then((response) => {
                console.log(response.data);
                this.showSuccessMessageWithButtonAndReload("Sucesso", "Incremento aplicado.");
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          } else {
            this.showErrorMessageWithButton("Ops...", "O tempo já se esgotou portanto não é possível alterá-lo.");
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarLeiloes();
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else if (!this.validateEmail()) {
        this.showErrorMessageWithButton("Ops...", "Digite um email válido!");
      } else if (this.senha == "") {
        this.showErrorMessageWithButton("Ops...", "A senha não pode ficar em branco!");
      } else {
        this.create();
      }
    },

    getFormatedTitle(title) {
      if (title && title.length > 28) {
        return title.substring(0, 28) + "...";
      } else {
        return title;
      }
    },

    getLeilaoPath(leilao) {
      if (leilao.path.includes("rochaleiloes2")) {
        return process.env.MIX_VUE_APP_S3_BASE2_URL + leilao.path + "/" + leilao.arquivo;
      } else if (leilao.path.includes("rochaleiloes") || leilao.arquivo.includes("fotos_")) {
        return process.env.MIX_VUE_APP_S3_BASE_URL + leilao.path + "/" + leilao.arquivo;
      } else {
        return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + leilao.path + "/" + leilao.arquivo;
      }
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas[this.paginas.length - 1] && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;

        this.buscarLeiloes(true);
      } else if (pagina == this.max_page && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;

        this.buscarLeiloes(true);
      }
    },

    buscarLeiloes() {
      this.isLoading = true;

      let data = {
        search: this.filtro,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
        leilao_id: this.leilao_id,
        filtro_leilao: this.filtro_leiloes,
      };

      if (this.dataInicial) {
        let aux_dataInicio = this.formatDateToSearch(this.dataInicial);
        data.data_inicio = aux_dataInicio;
      }

      if (this.dataFinal) {
        let aux_dataFim = this.formatDateToSearchTime(this.dataFinal);
        data.data_fim = aux_dataFim;
      }

      console.log("Busca");
      console.log(data);

      axios
        .post(`/admin/auditorio/search`, data)
        .then((response) => {
          console.log(response.data);

          this.isLoading = false;

          if (this.filtro && this.filtro != "") {
            this.searchBuscado = true;
          } else {
            this.searchBuscado = false;
          }

          this.leiloes = response.data.leiloes;
          this.total = response.data.total;

          this.pagination(response.data);
        })
        .catch((error) => {
           this.isLoading = false;
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },

    formatDateToSearch(date) {
      return moment(date, "DD/MM/yyyy").format("yyyy-MM-DD 00:00:00");
    },

    formatDateToSearchTime(date) {
      return moment(date, "DD/MM/yyyy").format("yyyy-MM-DD 23:59:59");
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          if (length - this.pagina_atual > 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    validateEmail() {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
        return true;
      } else {
        return false;
      }
    },

    generateKey() {
      return Math.random().toString(36).slice(2);
    },
  },
};
</script>

<style scoped>
.realizado {
  text-decoration: line-through;
}

.swal-modal {
  color: green;
  background-color: rgba(63, 255, 106, 0.69);
  border: 3px solid white;
}

.swal-overlay {
  background-color: rgba(43, 165, 137, 0.45);
}

.modal-content {
  width: 1700px;
  margin-left: -530px;
}

@media screen and (max-width: 2000px) {
  .modal-content {
    width: 1400px;
    margin-left: -430px;
  }
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 1200px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1100px) {
  .modal-content {
    width: 600px;
    margin-left: -20px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 960px) {
  .modal-content {
    width: 750px;
    margin-left: -120px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
